module.exports = __webpack_public_path__ + "static/media/S1N3-6.0f280a02.svg";